import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/skillsewa/r/skillsewa.com-trans/src/components/pages/designs/Designs.tsx");
